export default "__VITE_ASSET__8119079a__"